"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preventOverflowModifier = exports.offsetModifier = exports.hideOnScrollOrResizeModifier = exports.getModifiers = void 0;
const preventOverflowModifier = exports.preventOverflowModifier = {
  name: 'preventOverflow',
  enabled: true
};
const offsetModifier = exports.offsetModifier = {
  name: 'offset',
  enabled: true,
  options: {
    offset: [0, 10]
  }
};
const hideOnScrollOrResizeModifier = options => ({
  name: 'hideOnScroll',
  enabled: true,
  phase: 'write',
  fn: () => {},
  effect: ({
    state
  }) => {
    const passive = {
      passive: true
    };
    const scrollParents = [...state.scrollParents.reference, ...state.scrollParents.popper];
    scrollParents.forEach(scrollParent => {
      scrollParent.addEventListener('scroll', options.closePopover, passive);
    });
    window.addEventListener('resize', options.closePopover, passive);
    return () => {
      scrollParents.forEach(scrollParent => {
        scrollParent.removeEventListener('scroll', options.closePopover, passive);
      });
      window.removeEventListener('resize', options.closePopover, passive);
    };
  }
});
exports.hideOnScrollOrResizeModifier = hideOnScrollOrResizeModifier;
const getModifiers = options => [preventOverflowModifier, offsetModifier, hideOnScrollOrResizeModifier(options)];
exports.getModifiers = getModifiers;